import { forwardRef } from "react";
import './style.css'; // Import the external CSS

const PrintScores = forwardRef(({ scoreData }, ref) => {
    let slno = 1;

    const calculateAverage = (scores) => {
        const sum = scores.reduce((total, score) => total + score.score, 0);
        return sum / scores.length || 0; // Avoid division by zero
    };

    // Sum of marks
    const sumOfMarksSecured = scoreData.map(entry =>
        entry.scores.reduce((sum, score) => sum + score.score, 0)
    );

    const totalMarks = scoreData.map(entry =>
        entry.scores.reduce((sum, total_mark) => sum + total_mark.total_mark, 0)
    );

    // Percentage of marks
    const percent = (sumOfMarksSecured.reduce((acc, val) => acc + val, 0) * 100) / totalMarks.reduce((acc, val) => acc + val, 0);
    const formattedPercent = parseFloat(percent.toFixed(2));

    return (
        <div className="d-flex justify-content-center" style={{ width: "100%", margin: "auto" }}>
            <div ref={ref} className="print-only text-center w-75">
                <table style={{ width: "80%", margin: "auto" }}>
                    <thead>
                        <tr>
                            <th className='bg-primary text-light'>Name</th>
                            <th className='bg-primary text-light'>UID</th>
                            <th className='bg-primary text-light'>Academic Year</th>
                            <th className='bg-primary text-light'>Assessment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scoreData.map((entry, index) => (
                            <tr key={index}>
                                <td className='text-dark'>{entry.student}</td>
                                <td className='text-dark'>{entry.student_uid}</td>
                                <td className='text-dark'>{entry.ac_year}</td>
                                <td className='text-dark'>{entry.te}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                
                <table style={{ width: "80%", margin: "auto" }}>
                    <thead>
                        <tr>
                            <th className='bg-primary text-light'>Sl.No.</th>
                            <th className='bg-primary text-light'>Subject</th>
                            <th className='bg-primary text-light'>FM</th>
                            <th className='bg-primary text-light'>PM</th>
                            <th className='bg-primary text-light'>Secured Marks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scoreData.map((entry, index) => (
                            entry.scores.map((score, scoreIndex) => (
                                <tr key={`${index}-${scoreIndex}`}>
                                    <td className='text-dark'>{slno++}</td>
                                    <td className='text-dark'>{score.subject_name}</td>
                                    <td className='text-dark'>{score.total_mark}</td>
                                    <td className='text-dark'>
                                        {score.total_mark === 25 ? 15 : score.total_mark === 80 ? 30 : 33}
                                    </td>
                                    <td className='text-dark'>{score.score}</td>
                                </tr>
                            ))
                        ))}
                    </tbody>
                </table>
    
                <table style={{ width: "80%", margin: "auto" }}>
                    <thead>
                        <tr>
                            <th className='bg-primary text-light'>Total Marks</th>
                            <th className='bg-primary text-light'>Total Marks Secured</th>
                            <th className='bg-primary text-light'>Average</th>
                            <th className='bg-primary text-light'>Percentage (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-dark'>{totalMarks.reduce((acc, val) => acc + val, 0)}</td>
                            <td className='text-dark'>{sumOfMarksSecured.reduce((acc, val) => acc + val, 0)}</td>
                            <td className='text-dark'>{calculateAverage(scoreData.flatMap(entry => entry.scores)).toFixed(2)}</td>
                            <td className='text-dark'>{formattedPercent}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
    
});

export default PrintScores;
